import React from 'react';
import classNames from 'classnames';
import { Card } from '@/design-system';

export const EMPTY_CARD_HOLDER_IMG = '/img/empty-card-holder.svg';
export const EMPTY_CARD_HOLDER_2_IMG = '/img/empty-card-holder-2.svg';

export interface EmptyCardProps {
  className?: string;
  children: React.ReactNode;
  labelClassName?: string;
  version?: 'strong' | 'soft';
}

export const EmptyCard: React.FC<EmptyCardProps> = ({
  className,
  children,
  version = 'strong',
}) => {
  const holderSrc = version === 'strong' ? EMPTY_CARD_HOLDER_2_IMG : EMPTY_CARD_HOLDER_IMG;
  const containerClasses = classNames('flex flex-col min-w-0 max-w-full', className);

  return (
    <Card
      className={classNames(containerClasses, 'relative overflow-hidden pt-4 pb-3.5 pl-6 pr-8')}
    >
      <div className="absolute inset-x-0 top-0 h-12 bg-gradient-to-b from-black/5 to-transparent pointer-events-none z-10" />
      <div className="flex flex-col">
        <div className="flex items-center justify-between gap-3">
          <div className="flex-1 min-w-0 text-ds-text-4 text-ds-text font-normal leading-[1.4]">
            {children}
          </div>
          <div className="flex items-end justify-end shrink-0">
            <img
              src={holderSrc}
              alt=""
              width={134}
              height={98}
              className="shrink-0 object-contain pointer-events-none select-none"
              aria-hidden
              decoding="async"
            />
          </div>
        </div>
      </div>
    </Card>
  );
};
